// View scope picker (plan 8.2.2): only the scopes this screen allows the person — admin 나/전체 (+ team filter inside
// 전체), manager 나/우리 팀, member none (always "me"). Header on PC/tablet, top of the content on phones (CSS).
import { useT } from '../i18n';
import { useViewStore } from '../state/store';
import type { ViewScope } from '../state/url';
import { Seg, Select } from '../ui/Controls';
import { useView } from './view';

export function ScopeBar({ where }: { where: 'header' | 'main' | 'inline' }) {
  const t = useT();
  const view = useView();
  const setScope = useViewStore((s) => s.setScope);
  const setTeam = useViewStore((s) => s.setTeam);
  if (view.allowed.length < 2) return null;
  return (
    <div className={`scope-bar scope-bar--${where}`}>
      {where === 'main' ? (
        <span className="scope-bar__label" aria-hidden="true">
          {t('scope.label')}
        </span>
      ) : null}
      <Seg<ViewScope>
        label={t('scope.label')}
        size="sm"
        className="scope-seg"
        value={view.scope}
        items={view.allowed.map((sc) => ({ value: sc, label: t('scope.' + sc), icon: sc === 'me' ? 'user' : sc === 'team' ? 'users' : 'grid' }))}
        onChange={(v) => setScope(v)}
      />
      {view.teamFilterOn ? (
        <Select
          label={t('scope.teamFilterLabel')}
          hideLabel
          size="sm"
          className="scope-team"
          value={view.team ?? ''}
          options={[{ value: '', label: t('scope.allTeams') }, ...view.pickableTeams.map((tm) => ({ value: tm.id, label: tm.name }))]}
          onChange={(v) => setTeam(v || null)}
        />
      ) : null}
    </div>
  );
}
